import { componentName, CheckboxClass } from './CheckboxClass';
import '@vaadin/checkbox';
import '@vaadin/text-field';
import '@descope-ui/descope-enriched-text';
import '../descope-boolean-field-internal';

customElements.define(componentName, CheckboxClass);

export { CheckboxClass, componentName };
